module.exports = __webpack_public_path__ + "static/media/logo-main-white.8366fc53.svg";